import { MessageSquare, BellRing } from "lucide-react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { SupportInbox } from "@/components/dashboard/SupportInbox";
import { useSupport } from "@/context/SupportContext";
import { enablePush } from "@/lib/push";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const askPermission = async () => {
  try {
    const ok = await enablePush();
    if (ok) toast.success("Push notifications enabled — you'll be alerted even with the app closed");
    else toast.message("Notifications blocked — enable them in your browser settings");
  } catch (e) {
    toast.error(e.message);
  }
};

export const SupportButton = () => {
  const { unread, open, setOpen, enabled } = useSupport();
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    if (enabled && params.get("support") === "1") {
      setOpen(true);
      params.delete("support");
      setParams(params, { replace: true });
    }
  }, [enabled, params, setParams, setOpen]);
  if (!enabled) return null;
  const canAsk = !("Notification" in window) || Notification.permission === "default" || localStorage.getItem("aurora_push") !== "on";
  return (
    <>
      <button onClick={() => setOpen(true)} className="icon-btn relative" data-testid="nav-support-chat-button" aria-label="SpeechFlow Support chat" title="SpeechFlow Support chat">
        <MessageSquare size={16} />
        {unread > 0 && (
          <span className="absolute -right-2 -top-2 flex h-5 min-w-5 items-center justify-center rounded-full bg-[color:var(--au-red)] px-1 font-mono text-[10px] font-semibold text-white shadow-[0_0_10px_rgba(255,59,48,0.7)]" data-testid="nav-support-unread-badge">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent className="w-full rounded-none p-0 sm:max-w-md" data-testid="support-sheet">
          <SheetHeader className="border-b border-border p-4 text-left">
            <SheetTitle className="font-display">SpeechFlow Support</SheetTitle>
            <SheetDescription>Technical and support messages from the SpeechFlow team.</SheetDescription>
            {canAsk && (
              <button onClick={askPermission} className="btn-ghost mt-2 !h-9 w-fit !px-3 text-xs" data-testid="support-enable-notifications">
                <BellRing size={14} /> Enable notifications
              </button>
            )}
          </SheetHeader>
          <div className="p-3"><SupportInbox embedded /></div>
        </SheetContent>
      </Sheet>
    </>
  );
};
